<template>
  <v-layout align-center justify-center>
    <v-flex>
      <div class="payment">
        <span class="subheading font-weight-bold">Price: ${{printPrice(amount)}}</span>
        <div v-if="amount" ref="dropinLicense"></div>
        <div style="text-align: center;">
          <v-flex class="pa-5 blue--text title font-weight-light" v-if="loadingLicense">Loading&hellip;</v-flex>
          <v-flex class="red--text text--darken-2 subheading pt-2" v-if="settlement">Please wait&hellip;</v-flex>
          <!--<button class="btn btn-light waves-effect waves-light" style="float:left;" @click="goBack">Back</button>-->
          <v-flex>
            <v-layout row>
              <v-flex class="text-xs-left" v-if="isBackBtn">
                <v-btn flat class="pl-0 ml-0" @click="goBack"><span class="notranslate"><v-icon>keyboard_backspace</v-icon></span> Back</v-btn>
              </v-flex>
              <v-flex
                v-if="amount"
                class="text-xs-right">
                <button class="btn btn-success waves-effect waves-light" style="float:right;" ref="submitLicense" :disabled="loading">Pay now</button>
                <!--<v-btn color="success" ref="submitLicense" :disabled="loading">Pay now</v-btn>-->
              </v-flex>
            </v-layout>
          </v-flex>
        </div>
        <v-dialog
          v-model="transactionSuccessful"
          :width="$store.getters.getAppWidth - 10"
        >
          <v-card>
            <v-card-title
              class="headline green white--text">
              License transaction successful
              <v-spacer></v-spacer>
              <span class="notranslate"><v-icon style="color:#fff;">check</v-icon></span>
            </v-card-title>

            <v-card-text>
              <v-flex>You are licensed for all levels, exams and certification. </v-flex>

              <v-flex class="mt-1">Soon, you will receive confirmation email.</v-flex>

              <v-flex>
                <strong>Transaction Id:</strong> <span class="primary--text subheading"
                                                       style="font-size: 18px!important;">{{braintreeTransactionId}}</span>
              </v-flex>
              <em>Please note transaction id for future reference.</em>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                flat
                @click="transactionSuccessful = false"
              >
                Home
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </v-flex>
  </v-layout>

</template>

<script>
  import dropIn from 'braintree-web-drop-in'
  import axios from 'axios'

  export default {
    props: {
      token: {
        required: true
      },
      locale: {
        default: 'en_US'
      },
      name: {
        default: 'NO'
      },
      paypal: {
        default: false
      },
      isBackBtn: {
        default: true
      },
      userId: {
        default: -1
      },
      memberId: {
        default: -1
      },
      orderId: {
        default: -1
      },
      amount: {
        default: -1
      },
      page: {
        default: 'unknown'
      },
      selectedCouponId: {
        default: null
      }
    },
    computed: {
      cognetiToken () {
        return this.$store.getters['token']
      },
      transactionSuccessful: {
        get: function () {
          return this.$store.getters['braintree/getTransactionSuccessfulLicense']
        },
        set: function (status) {
          this.$store.commit('braintree/setTransactionSuccessfulLicense', status)
        }
      }
    },
    data () {
      return {
        settlement: false,
        braintreeTransactionId: -1,
        url: process.env.API_URL + `/ws/checkout/transact`,
        loading: true, // When a payment is processed, prevents double clicks
        loadingLicense: true,
        disabled: false // When a payment is successfully processed, the entire component is disabled
      }
    },
    mounted () {
      var vm = this
      this.transactionSuccessful = false
      this.settlement = false
      // Create config
      let config = {
        authorization: this.token,
        container: this.$refs.dropinLicense,
        locale: this.locale
      }

      // eslint-disable-next-line no-console
      console.log('name=', this.name)

      // If Paypal is available
      if (this.paypal) {
        config.paypal = {
          flow: 'vault'
        }
      }
      const store = this.$store
      const amount = this.amount
      if (amount) {
        dropIn.create(config, function (createErr, instance) {
          // console.log('Dropin Create')
          vm.$emit('loaded')
          vm.loading = false
          vm.loadingLicense = false
          vm.$refs.submitLicense.addEventListener('click', function () {
            if (!vm.loading && !vm.disabled) {
              instance.requestPaymentMethod(function (err, payload) {
                if (err) {
                  // No payment method is available.
                  // An appropriate error will be shown in the UI.
                  store.commit('flashError', err.message, {root: true})
                  console.error(err)
                  return
                }
                vm.loading = true
                // eslint-disable-next-line no-console
                console.log('NOW PAYING', amount)
                vm.pay(payload.nonce, amount)
              })
            }
          })
        })
      } else {
        // this.$store.commit('flashError', 'API Error, unable to get amount.', {root: true})
        this.pay(null, amount)
      }
    },
    destroyed () {
      // this.$refs.submit.removeEventListenter('click')
    },
    methods: {
      printPrice (price) {
        return Number.isInteger(price) ? price : price.toFixed(2)
      },
      goBack () {
        this.$store.commit('braintree/setClientToken', 0)
      },
      pay (nonce, amount) {
        if (!this.userId) {
          console.error('User:', this.userId)
          this.$store.commit('flashError', 'Error, unable to get user info.', {root: true})
          return false
        }
        if (!this.memberId) {
          console.error('memberId:', this.memberId)
          this.$store.commit('flashError', 'Error, unable to get member info.', {root: true})
          return false
        }
        this.transactionSuccessful = false
        let data = {
          userId: this.userId,
          memberId: this.memberId,
          pmNonce: nonce,
          courseId: process.env.GAME_ID,
          productId: 'SFHTier1',
          amount: amount,
          description: 'php-client'
        }
        if (this.selectedCouponId) {
          data.couponId = this.selectedCouponId
        }
        this.settlement = true
        axios({
          url: this.url,
          method: 'POST',
          data,
          headers: {
            Authorization: 'Bearer ' + this.cognetiToken
          }
        }).then(response => {
          this.$store.commit('braintree/setClientToken', 0)
          if (amount) {
            if (response.data.transactionId) {
              this.$store.commit('flashSuccess', 'Congratulations, payment has been done.', {root: true})
              this.braintreeTransactionId = response.data.transactionId
              this.transactionSuccessful = true
              if (this.$route.name === 'QuickPayment') {
                this.$router.push({ path: '/' })
              }
            } else {
              this.$store.commit('flashError', 'Error, something went wrong. Please contact us for further assistance.', {root: true})
              this.transactionSuccessful = false
              if (this.$route.name === 'QuickPayment') {
                this.$router.push({ path: '/' })
              } else {
                this.goBack()
              }
            }
          } else {
            this.$store.commit('flashSuccess', 'Congratulations, process has been done.', {root: true})
            this.braintreeTransactionId = 'Free user'
            this.transactionSuccessful = true
            if (this.$route.name === 'QuickPayment') {
              this.$router.push({ path: '/' })
            }
          }

          this.loading = false
          this.disabled = true
          this.settlement = false
        }).catch(error => {
          this.transactionSuccessful = false
          this.$store.commit('flashError', error.response.data, { root: true })
          this.loading = false
          if (this.$route.name === 'QuickPayment') {
            console.error('amount is 0 catch', this.amount)
            this.$router.push({ path: '/' })
          }
        })
      }
    }
  }
</script>
<style>
  .btn-success.disabled, .btn-success:disabled {
    color: #fff;
    background-color: #28a745;
    border-color: #28a745;
  }
  .btn.disabled, .btn:disabled {
    opacity: .65;
  }
  .btn-success {
    background-color: #00c851!important;
    color: #fff!important;
  }

  .waves-effect {
    position: relative;
    cursor: pointer;
    overflow: hidden;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-tap-highlight-color: transparent;
  }
  .btn-success:not([disabled]):not(.disabled).active, .btn-success:not([disabled]):not(.disabled):active, .show>.btn-success.dropdown-toggle {
    box-shadow: 0 5px 11px 0 rgba(0,0,0,.18), 0 4px 15px 0 rgba(0,0,0,.15);
    background-color: #006228!important;
  }
  .btn-success:not(:disabled):not(.disabled).active, .btn-success:not(:disabled):not(.disabled):active, .show>.btn-success.dropdown-toggle {
    color: #fff;
    background-color: #1e7e34;
    border-color: #1c7430;
  }
  .btn.btn-lg {
    padding: 1rem 2.4rem;
    font-size: .94rem;
  }
  .btn:active, .btn:focus, .btn:hover {
    outline: 0;
    box-shadow: 0 5px 11px 0 rgba(0,0,0,.18), 0 4px 15px 0 rgba(0,0,0,.15);
  }
  .btn-light:hover {
    background-color: #ededed;
    color: #000;
  }
  .btn:active, .btn:focus, .btn:hover {
    outline: 0;
    box-shadow: 0 5px 11px 0 rgba(0,0,0,.18), 0 4px 15px 0 rgba(0,0,0,.15);
  }
  .btn-light:hover {
    color: #212529;
    background-color: #e2e6ea;
    border-color: #dae0e5;
  }
  .btn-light {
    background-color: #e0e0e0!important;
    color: #000;
  }
  .btn {
    margin: .375rem;
    color: inherit;
    text-transform: uppercase;
    word-wrap: break-word;
    white-space: normal;
    cursor: pointer;
    border: 0;
    border-radius: .125rem;
    box-shadow: 0 2px 5px 0 rgba(0,0,0,.16), 0 2px 10px 0 rgba(0,0,0,.12);
    transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    padding: .74rem 2.14rem;
    font-size: .91rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/widgets/LicensePayment.vue